import { memo, useState, useRef, useCallback, useMemo } from "react";

import { CollectionVideoCardView } from "@components/CollectionContentCard/CollectionVideoCard.view";
import { type CollectionContentCard } from "@root/tablescape/state";

type Props = Pick<
  CollectionContentCard,
  "videoControlColor" | "videoMp4" | "videoWebm"
>;

export const CollectionVideoCardBase = ({
  videoControlColor = "char",
  videoMp4,
  videoWebm,
}: Props) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  const videoSources = useMemo(() => {
    const sources = [];
    if (videoWebm?.sources) {
      sources.push(...videoWebm.sources);
    }
    if (videoMp4?.sources) {
      sources.push(...videoMp4.sources);
    }
    return sources;
  }, [videoWebm, videoMp4]);

  const handleToggleVideo = useCallback(() => {
    if (videoRef?.current) {
      if (isVideoPlaying) {
        videoRef.current.pause();
        setIsVideoPlaying(false);
      } else {
        videoRef.current.play();
        setIsVideoPlaying(true);
      }
    }
  }, [isVideoPlaying, setIsVideoPlaying, videoRef]);

  return (
    <CollectionVideoCardView
      isVideoPlaying={isVideoPlaying}
      onToggleVideo={handleToggleVideo}
      videoControlColor={videoControlColor}
      videoRef={videoRef}
      videoSources={videoSources}
    />
  );
};

export const CollectionVideoCard = memo(CollectionVideoCardBase);
